__turbopack_context__.v({
  "gridLogo": "Portfolio-module__wMt7sa__gridLogo",
  "portfolioSection": "Portfolio-module__wMt7sa__portfolioSection",
  "skillGrid": "Portfolio-module__wMt7sa__skillGrid",
  "skillsSection": "Portfolio-module__wMt7sa__skillsSection",
});
